import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section eyebrow="FAQ" title="Frequently asked questions" alt data-id="element-83" data-mp="1l9fvvmf2j4d6">
      <div className="mx-auto max-w-2xl space-y-3" data-id="element-84" data-mp="1ge8w2pox6jtj">
        {faqs.map((faq, i) => {
        const isOpen = open === i;
        return <div key={faq.q} className="overflow-hidden rounded-2xl border border-white/10 bg-ink-800" data-id="element-85" data-mp="291mkfzejy721" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-86" data-mp="240yy3r19qee5">
                <span className="text-sm font-bold leading-snug text-white sm:text-base" data-id="element-87" data-mp="nniha03t7j6i">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-lime transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-88" data-mp="pih9i90itbuq" />
              </button>
              {isOpen ? <p className="px-4 pb-4 text-sm leading-relaxed text-white/65" data-id="element-89" data-mp="kil5i9rtpkf6">{faq.a}</p> : null}
            </div>;
      })}
      </div>

      <div className="mx-auto max-w-md" data-id="element-90" data-mp="6q59hsxcamnr">
        <SectionCta headline="Still deciding? You’re covered by the 7-day guarantee." data-id="element-91" data-mp="bhwsnie61q3v" />
      </div>
    </Section>;
}